"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineFeature = defineFeature;
function defineFeature(featureDef) {
    return featureDef;
}
